import { PrimaryButton } from "@shared/buttons";

export const SubmitTicketButton = () => (
  <PrimaryButton
    className="w-fit uppercase"
    onClick={() => {
      window.open("https://www.northbeam.io/submit-a-support-ticket", "_blank");
    }}
  >
    Submit a ticket
  </PrimaryButton>
);
